import { Injectable, signal } from '@angular/core';
import { ActivityViewerItem } from '../types/activity-viewer/activity-viewer.types';

@Injectable()
export abstract class SharedBaseActivityViewerService {
  activityItems = signal<ActivityViewerItem[]>([]);
  totalActivities = signal<number>(0);
  selectedActivity = signal<ActivityViewerItem | null>(null);
  isLoading = signal<boolean>(false);
  drawerCollapsed = signal<boolean>(false);
  activeInstanceId = signal<string | null>(null);

  abstract initializeInstance(
    instanceId: string,
    scopeKey: string,
    options?: {
      initialActivityId?: string | number | null;
      drawerCollapsed?: boolean;
    }
  ): void;

  abstract setSelectedActivityById(activityId: string | number | null): void;

  abstract refreshActivities(options?: { limit?: number; offset?: number }): void;

  setSelectedActivity(activity: ActivityViewerItem | null): void {
    this.setSelectedActivityById(activity?.activityId ?? null);
  }

  abstract setDrawerCollapsed(collapsed: boolean): void;
}
